import KendoArcGauge from './KendoArcGauge'
import KendoArcGaugeColor from './KendoArcGauge/KendoArcGaugeColor'
import KendoLinearGauge from './KendoLinearGauge'
import KendoLinearGaugePointer from './KendoLinearGauge/KendoLinearGaugePointer'
import KendoRadialGauge from './KendoRadialGauge'
import KendoRadialGaugePointer from './KendoRadialGauge/KendoRadialGaugePointer'
import KendoGaugesInstaller from './kendo-gauges-installer'

export { KendoArcGauge, KendoArcGauge as ArcGauge, KendoArcGaugeColor, KendoArcGaugeColor as ArcGaugeColor, KendoLinearGauge, KendoLinearGauge as LinearGauge, KendoLinearGaugePointer, KendoLinearGaugePointer as LinearGaugePointer, KendoRadialGauge, KendoRadialGauge as RadialGauge, KendoRadialGaugePointer, KendoRadialGaugePointer as RadialGaugePointer, KendoGaugesInstaller, KendoGaugesInstaller as GaugesInstaller }


// WEBPACK FOOTER //
// ./packages/kendo-gauges-vue-wrapper/src/index.js